import * as types from './types';

/**
 * ---------------------------------------------------
 * INDICADORES DO PAINEL GERAL
 * ---------------------------------------------------
 */

export function getIndicatorsPgRequest(payload) {
  return {
    type: types.GET_INDICATORS_PG_REQUEST,
    payload,
  };
}

export function getIndicatorsPgSuccess(payload) {
  return {
    type: types.GET_INDICATORS_PG_SUCCESS,
    payload,
  };
}

export function getIndicatorsPgFailure(payload) {
  return {
    type: types.GET_INDICATORS_PG_FAILURE,
    payload,
  };
}

/**
 * ---------------------------------------------------
 * INDICADORES DO PAINEL GERAL - ATIVAR
 * ---------------------------------------------------
 */

export function activeIndicatorsPgRequest(payload) {
  return {
    type: types.ACTIVE_INDICATORS_PG_REQUEST,
    payload,
  };
}

export function activeIndicatorsPgSuccess(payload) {
  return {
    type: types.ACTIVE_INDICATORS_PG_SUCCESS,
    payload,
  };
}

export function activeIndicatorsPgFailure(payload) {
  return {
    type: types.ACTIVE_INDICATORS_PG_FAILURE,
    payload,
  };
}

/**
 * ---------------------------------------------------
 * INDICADORES DO PAINEL GERAL - INATIVAR
 * ---------------------------------------------------
 */

export function inactiveIndicatorsPgRequest(payload) {
  return {
    type: types.INACTIVE_INDICATORS_PG_REQUEST,
    payload,
  };
}

export function inactiveIndicatorsPgSuccess(payload) {
  return {
    type: types.INACTIVE_INDICATORS_PG_SUCCESS,
    payload,
  };
}

export function inactiveIndicatorsPgFailure(payload) {
  return {
    type: types.INACTIVE_INDICATORS_PG_FAILURE,
    payload,
  };
}

/**
 * ---------------------------------------------------
 *  ESTRATIFICAÇÃO - ATIVAR
 * ---------------------------------------------------
 */

export function activeEstratRequest(payload) {
  return {
    type: types.ACTIVE_ESTRAT_REQUEST,
    payload,
  };
}

export function activeEstratSuccess(payload) {
  return {
    type: types.ACTIVE_ESTRAT_SUCCESS,
    payload,
  };
}

export function activeEstratFailure(payload) {
  return {
    type: types.ACTIVE_ESTRAT_FAILURE,
    payload,
  };
}

/**
 * ---------------------------------------------------
 * ESTRATIFICAÇÃO - INATIVAR
 * ---------------------------------------------------
 */

export function inactiveEstratRequest(payload) {
  return {
    type: types.INACTIVE_ESTRAT_REQUEST,
    payload,
  };
}

export function inactiveEstratSuccess(payload) {
  return {
    type: types.INACTIVE_ESTRAT_SUCCESS,
    payload,
  };
}

export function inactiveEstratFailure(payload) {
  return {
    type: types.INACTIVE_ESTRAT_FAILURE,
    payload,
  };
}
